import type { DashboardWidget } from "./types";

/**
 * O conjunto de cards do painel, sem contar ninguém duas vezes.
 *
 * POR QUE ISTO PRECISA EXISTIR. Os cards do painel vêm de duas origens: os que
 * o operador salvou e as PRÉVIAS AUTOMÁTICAS derivadas do `/meta`. As prévias
 * são recalculadas a cada render, sempre, e carregam id estável
 * (`starter-<fonte>`). Quando o operador configura uma prévia, o widget salvo
 * mantém esse mesmo id — passa a existir nas DUAS listas.
 *
 * Concatenar as duas produzia um array com o id repetido: primeiro a versão
 * configurada, depois a automática. Qualquer código que percorresse esse array
 * gravando widget por widget aplicava as duas, nessa ordem — e a automática,
 * por vir depois, apagava a configuração do operador.
 *
 * O defeito aparecia ao MOVER um card: um toque de seta e o título, a unidade,
 * as casas decimais e a regra de produção voltavam ao padrão. O operador via o
 * próprio trabalho sumir sem nenhuma mensagem, num gesto que ele não associa a
 * risco nenhum — arrastar um card de lugar.
 *
 * O SALVO VENCE, sempre. A prévia automática existe para preencher o painel
 * antes de alguém escolher qualquer coisa; assim que há escolha, ela não tem
 * mais nada a dizer sobre aquele card.
 */
export function mesclarWidgets(
  salvos: readonly DashboardWidget[],
  automaticos: readonly DashboardWidget[],
): DashboardWidget[] {
  const porId = new Map<string, DashboardWidget>();
  // Automáticos primeiro para que os salvos sobrescrevam, e não o contrário.
  // A ordem de INSERÇÃO do Map é preservada, então um card que existe nas duas
  // listas mantém a posição da prévia — o painel não se reembaralha quando um
  // card passa de automático a salvo.
  for (const widget of automaticos) porId.set(widget.id, widget);
  for (const widget of salvos) porId.set(widget.id, widget);
  return [...porId.values()];
}
